var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fit flex flex-center items-start mt-20"},[_c(_setup.AssetsSelect,{model:{value:(_setup.selection),callback:function ($$v) {_setup.selection=$$v},expression:"selection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }